import React, { useMemo } from 'react'
import styled from 'styled-components'
import { FilteredPropertyData } from '../../../types/PropertyData'
import Button from '../Button'

export type ButtonsProps = {
  propertyData: FilteredPropertyData
  value?: string
  setValue?: (nextValue: string) => void
  className?: string
}

const Buttons = styled<React.FC<ButtonsProps>>(function Buttons({ propertyData, value, setValue, className }) {
  const options = useMemo(
    () =>
      propertyData.values
        .filter((x) => !x.disabled || x.disabled.type === 'disabled')
        .map((value) => ({ value, select: () => setValue?.(value.id) })),
    [propertyData.values, setValue]
  )

  return (
    <div className={className}>
      {propertyData.displayName}

      {options.map(({ value: optionValue, select }) => (
        <div key={optionValue.id}>
          <Button onClick={select} disabled={!!optionValue.disabled} cta={optionValue.id === value}>
            {optionValue.displayName}
          </Button>
        </div>
      ))}
    </div>
  )
})`
  margin-bottom: 5px;

  ${Button} {
    width: 100%;
  }
`

export default Buttons
